import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  background-color: #fafafa;
  min-height: 100vh;
`;

export const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 2rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

export const WatchesContent = styled.div`
  flex: 1;
`;

export const WatchesHeader = styled.div`
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
`;

export const PageTitle = styled.h1`
  font-family: 'Abel', sans-serif;
  font-size: 2.5rem;
  font-weight: 300;
  letter-spacing: 2px;
  color: ${({ theme }) => theme.colors.main};
  margin-bottom: 0.5rem;
  border-left: 4px solid ${({ theme }) => theme.colors.main};
  padding-left: 0.85rem;
`;

export const WatchesCount = styled.p`
  font-family: 'Abel', sans-serif;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;

export const WatchGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  @media (min-width: 1600px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
`;

export const LoadingMessage = styled.p`
  text-align: center;
  font-family: 'Abel', sans-serif;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  padding: 4rem 2rem;
`;

export const NoResults = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  
  p {
    font-family: 'Abel', sans-serif;
    font-size: 1.1rem;
    color: ${({ theme }) => theme.colors.text.secondary};
    margin: 0;
  }
`;